//@flow strict
import * as React from 'react';
import classify from 'src/utils/classify';

import css from './horizontal-separator.css';


export const HorizontalSeparator = ({
  className,
}: {
  className?: string,
}): React.Node => <div className={classify(css.separator, className)}></div>;
